import { render, staticRenderFns } from "./Blogs.vue?vue&type=template&id=a99419ac&scoped=true&"
import script from "./Blogs.vue?vue&type=script&lang=ts&"
export * from "./Blogs.vue?vue&type=script&lang=ts&"
import style0 from "./Blogs.vue?vue&type=style&index=0&id=a99419ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99419ac",
  null
  
)

export default component.exports